import {Component, Input, OnInit} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgIf, NgClass, DecimalPipe } from '@angular/common';

export interface BTDataType {
  // Titre de la box
  name: string | null;
  // Nom de l'icon (par ex: add, close)
  icon: string | null;
  // Type d'icone utilisée. Si 'other' fournir tout ce qu'il faut.
  icon_type?: PossibleIconType;
  // Si material icon, renseigné sa class. Par défaut : material-icons-outlined
  icon_class?:string;
  // Information display
  info: any;
  // Type d'information display. Si "age", calcul fait dans le composant.
  info_type: PossibleInfoType | null;
}

const PossibleIconType = {
  mt: 'material' as 'material',
  mi: 'mat-icon' as 'mat-icon',
  i: 'img' as 'img',
  o: 'other' as 'other',
}
type PossibleIconType = (typeof PossibleIconType)[keyof typeof PossibleIconType];
export {PossibleIconType};

const PossibleInfoType = {
  c: 'clef' as 'clef',
  n: 'number' as 'number',
  a: 'age' as 'age',
  s: 'string' as 'string',
}
type PossibleInfoType = (typeof PossibleInfoType)[keyof typeof PossibleInfoType];
export {PossibleInfoType};

@Component({
    selector: 'app-bordered-tiles-informations',
    templateUrl: './bordered-tiles-informations.component.html',
    styleUrls: ['./bordered-tiles-informations.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf, NgClass, DecimalPipe, TranslateModule]
})
export class BorderedTilesInformationsComponent implements OnInit {

  /*Required. Un tableau avec toutes les variables souhaitées.
  * - Si info_type = age ; mettre la date dans 'info'.
  * - si info_type = number, l'arrondis se fait automatiquement.
  * */
  @Input() data: BTDataType[] = [{name: 'title', icon: 'add', icon_type: 'material', info: 'info', info_type: 'number', icon_class: null}] ;
  // Optionnel. Défaut : ''. Configure le comportement des box.
  @Input() behavior;



  constructor() {
  }

  ngOnInit(): void {
    this.data.forEach(d => {
      // Calcul de l'âge
      if (d.info_type == 'age') {
        d['age'] = this.calculateAge(d.info);
      }
      // Vérifie le type de variable pour éviter les erreurs
      if (d.info_type == 'number' && typeof d.info == 'string') {
        d.info_type = 'string';
      }
      if ((d.info_type == 'string' || d.info_type == 'clef') && typeof d.info == 'number') {
        d.info_type = 'number';
      }
    })
  }

  private calculateAge(birthdate): number | string {
    if (birthdate) {
      const timeDiff = Math.abs(Date.now() - new Date(birthdate).getTime());
      return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    }
   return 'N/A'
  }

  // @TODO : retirer le scroll
  onWheel(event: WheelEvent): void {

    if (event.deltaY > 0) document.getElementById('container')!.scrollLeft += 40;
    else document.getElementById('container')!.scrollLeft -= 40;
  }

}
